import { faComment } from '@fortawesome/pro-light-svg-icons';
import {
  faCheckCircle,
  faHistory,
  faTag,
  faUserPlus,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import Address from '../../components/Address/Address';
import CancelBookingWizard from '../../components/CancelBookingWizard/CancelBookingWizard';
import CancellationPolicy from '../../components/CancellationPolicy/CancellationPolicy';
import CancellationPolicyModal from '../../components/CancellationPolicyModal/CancellationPolicyModal';
import ChangeBookingOptionsWizard from '../../components/ChangeBookingOptionsWizard/ChangeBookingOptionsWizard';
import ChangeBookingWizard from '../../components/ChangeBookingWizard/ChangeBookingWizard';
import ChangeDateTimeWizard from '../../components/ChangeDateTimeWizard/ChangeDateTimeWizard';
import CheckAvailabilitySuccess from '../../components/CheckAvailabilitySuccess/CheckAvailabilitySuccess';
import CheckAvailabilityWizard from '../../components/CheckAvailabilityWizard/CheckAvailabilityWizard';
import ContactModal from '../../components/ContactModal/ContactModal';
import CtaBtn from '../../components/CtaBtn/CtaBtn';
import Faqs from '../../components/Faqs/Faqs';
import LoginWizard from '../../components/LoginWizard/LoginWizard';
import NeedHelp from '../../components/NeedHelp/NeedHelp';
import PricingInclusions from '../../components/PricingInclusions/PricingInclusions';
import ProfileAlertBar from '../../components/ProfileAlertBar/ProfileAlertBar';
import ProfileFomoSection from '../../components/ProfileFomoSection/ProfileFomoSection';
import ProfileFooter from '../../components/ProfileFooter/ProfileFooter';
import ProviderProfileSection from '../../components/ProviderProfileSection/ProviderProfileSection';
import ProviderProfileTestimonialsSection from '../../components/ProviderProfileTestimonialsSection/ProviderProfileTestimonialsSection';
import RescheduleBookingWizard from '../../components/RescheduleBookingWizard/RescheduleBookingWizard';
import MediaContainer from '../../containers/MediaContainer/MediaContainer';
import ProviderProfilePageContainer from '../../containers/ProviderProfilePageContainer/ProviderProfilePageContainer';
import ReviewsContainer from '../../containers/ReviewsContainer/ReviewsContainer';
import { Button, ReadMore } from '../../flayr-components';
import useDeviceMediaQuery from '../../hooks/useDeviceMediaQuery';
import CheckCircle from '../../lib/CheckCircle/CheckCircle';
import ConditionalWrapper from '../../lib/ConditionalWrapper/ConditionalWrapper';
import Distance from '../../lib/Distance/Distance';
import Drawer from '../../lib/Drawer/Drawer';
import ErrorMsg from '../../lib/ErrrorMsg/ErrorMsg';
import FormattedDate from '../../lib/FormattedDate/FormattedDate';
import PageMetaData from '../../lib/PageMetaData/PageMetaData';
import { ScrollSpyContextProvider } from '../../lib/ScrollSpy/ScrollSpypContext';
import SlideIn from '../../lib/SlideIn/SlideIn';
import SuccessErrDrawer from '../../lib/SuccessErrDrawer/SuccessErrDrawer';
import SuccessModal from '../../lib/SuccessModal/SuccesModal';
import SuccessMsg from '../../lib/SuccessMsg/SuccessMsg';
import Time from '../../lib/Time/Time';
import OfferDetailsSection from '../../page-components/OfferDetailsSection';
import OtherOffersSection from '../../page-components/ProfilePage/OtherOffersSection';
import ProfileAvatarSection from '../../page-components/ProfilePage/ProfileAvatarSection';
import ReasonsToBook from '../../page-components/ProfilePage/ReasonsToBook';
import RescheduleSection from '../../pages/customerPages/OfferPage/components/RescheduleSection/RescheduleSection';
import ReviewsSection from '../../pages/customerPages/OfferPage/components/ReviewsSection/ReviewsSection';
import ProviderProfileMediaSection from '../../pages/customerPages/ProviderProfilePage/components/ProviderProfileMediaSection/ProviderProfileMediaSection';
import TestimonialContainer from '../../pages/customerPages/ProviderProfilePage/containers/TestimonialContainer/TestimonialContainer';
import ProviderProfileCollapseContainer from '../../pages/customerPages/ProviderProfilePage/ProviderProfileCollapseContainer/ProviderProfileCollapseContainer';
import { TAppointmentStatus } from '../../types/appointment';
import ProfileDisplayLayout from '../ProfileDisplayLayout/ProfileDisplayLayout';
import {
  bookedFaqs,
  defaultFaqs,
  inclusions,
  offeredFaqs,
  requestedFaqs,
} from './profilePageLayoutStaticData';

interface IProfilePageLayoutProps {
  fetchDataUrl?: string;
  checkAvailabilityUrl?: string;
  fetchMediaUrl?: string;
  fetchTestimonialsUrl?: string;
  fetchReviewsUrl?: string;
  mobileOrStudio?: 'mobile' | 'studio';
  offerKey?: string;
}

const ProfilePageLayout: React.FC<
  React.PropsWithChildren<IProfilePageLayoutProps>
> = ({
  fetchDataUrl = '',
  mobileOrStudio,
  offerKey,
  checkAvailabilityUrl = '',
  fetchMediaUrl = '',
  fetchTestimonialsUrl = '',
  fetchReviewsUrl = '',
}) => {
  const { isDesktop } = useDeviceMediaQuery();

  return (
    <ProviderProfilePageContainer
      url={fetchDataUrl}
      checkAvailabilityUrl={checkAvailabilityUrl}
      mobileOrStudio={mobileOrStudio}
      offerKey={offerKey}
    >
      {({
        profileId,
        handleBack,
        offer,
        provider,
        search,
        handleCtaClick,
        cancellationPolicyModal,
        newDateTimeModal,
        handleTimeChangeSubmit,
        contactModal,
        dateTimeChangeSuccessModal,
        checkAvailabilityModal,
        customer,
        checkAvailabilitySuccessModal,
        handleCheckAvailabilityFinish,
        watchersCount,
        contactProviderSuccessModal,
        handleOfferExpired,
        loading,
        bookingCancellationModal,
        offerId,
        handleCancelBookingComplete,
        rescheduleModal,
        handleRescheduleComplete,
        successMsg,
        clearSuccessMsg,
        errMsg,
        clearErrMsg,
        handleAcceptReschedule,
        loginModal,
        handleCancelChangeRequest,
        changePackageModal,
        handleChangePackage,
        handleLoginComplete,
        changeModal,
        handleChangeOptionSelect,
        otherOffers = [],
      }) => {
        const offerSuccess =
          ([
            'booked',
            'rescheduleRequested',
            'changePackageRequested',
            'changePackageOffered',
          ].includes(offer?.status) &&
            'Booked') ||
          '';

        const offerBooked = [
          'booked',
          'rescheduleRequested',
          'rescheduleOffered',
          'changePackageRequested',
          'changePackageOffered',
        ].includes(offer?.status);

        const offerErr =
          (offer?.status === 'offerExpired' && 'Offer Expired') ||
          ([
            'declined',
            'offerExpired',
            'bookedOut',
            'dismissed',
            'expired',
          ].includes(offer?.status) &&
            'Booked Out') ||
          ([
            'cancelled',
            'cancelledByCustomer',
            'cancelledByProvider',
            'cancelledByFlayr',
          ].includes(offer?.status) &&
            'Booking Cancelled') ||
          (offer?.status === 'closed' && 'Request Closed') ||
          '';

        const ctaLabel =
          (['requested'].includes(offer?.status) && 'Checking Availability') ||
          (['offered', 'timeChangeRequested'].includes(offer?.status) &&
            `Book now`) ||
          (offer?.status === 'offerExpired' && 'Request again') ||
          ([
            'cancelled',
            'cancelledByCustomer',
            'cancelledByProvider',
            'cancelledByFlayr',
          ].includes(offer?.status) &&
            'Contact Flayr') ||
          (offer?.status === 'rescheduleOffered' && 'Accept New Spot') ||
          'Check Availability';

        const navbarLinks = [
          'appointment',
          'pricing',
          'bio',
          'reviews',
          'FAQs',
        ].filter((link) => {
          if (['appointment', 'pricing'].includes(link) && !offer) {
            return false;
          }
          return (
            link !== 'reviews' ||
            (provider?.review?.totalCount && link === 'reviews')
          );
        });

        let faqs: any[] = [];
        switch (offer?.status) {
          case 'requested':
            faqs = requestedFaqs;
            break;
          case 'offered':
            faqs = offeredFaqs;
            break;
          case 'booked':
            faqs = bookedFaqs;
            break;
          default:
            faqs = defaultFaqs;
        }

        const offerDetailsSection = {
          locationLabel:
            (offer?.location.mobileOrStudio === 'mobile' &&
              'Stylist comes to you in') ||
            'You visit the stylist in',
          location: offer?.location.address || (
            <>
              <Address address={offer?.location?.addressFull} minimal />
              {offer?.location.mobileOrStudio === 'studio' && (
                <div className="text-sm leading-[1.5em] mt-1.5 font-normal lg:text-lg">
                  Distance:{' '}
                  <Distance
                    distanceInMeters={offer?.location?.distance?.inMeters}
                    unit={offer?.location?.distance?.unit}
                  />
                </div>
              )}
            </>
          ),
          dateLabel:
            (!!offer?.appointmentSpot?.startTime && 'Appointment Time') ||
            'To be Ready By',
          date: (
            <>
              <FormattedDate
                date={
                  offer?.appointmentSpot?.eventDate ||
                  search?.appointmentSpot?.eventDate
                }
                format="dddd, MMM DD YYYY"
              />
              ,<br hidden={!offer?.appointmentSpot?.startTime} />{' '}
              {(!!offer?.appointmentSpot?.startTime && (
                <>
                  <Time time={offer?.appointmentSpot.startTime} /> -{' '}
                  <Time time={offer?.appointmentSpot.finishTime} />{' '}
                  {offer?.status === 'offered' && (
                    <>
                      {offer?.appointmentSpot?.isOtherSpotsAvailable && (
                        <button
                          className="block px-5 py-2 mt-1 text-xs font-normal border rounded-full cursor-pointer border-primary text-primary"
                          onClick={newDateTimeModal.toggle}
                          hidden={offer?.status !== 'offered'}
                        >
                          Request new Date/Time
                        </button>
                      )}
                    </>
                  )}
                  {!offer?.appointmentSpot?.isOtherSpotsAvailable && (
                    <span className="block mt-1 text-xs font-normal text-red-500 lg:text-base">
                      Provider only has this time
                    </span>
                  )}
                  {offer?.status === 'timeChangeRequested' && (
                    <div className="flex items-center py-2 mt-1 space-x-2 text-xs font-normal text-primary">
                      <FontAwesomeIcon icon={faCheckCircle} />
                      <span>Date/Time change requested</span>
                    </div>
                  )}
                </>
              )) || <Time time={search?.appointmentSpot?.finishTime} />}
            </>
          ),
          servicesLabel: 'Services',
          services:
            offer?.services?.map(({ service, serviceType }) => [
              serviceType.label,
              service.label,
            ]) || [],
        };

        const kit = provider?.kit?.filter((k) => k.trim()) || [];

        const isCtaHidden = (
          [
            'deleted',
            'booked',
            'bookedOut',
            'declined',
            'dismissed',
            'expired',
            'rescheduleRequested',
            'closed',
            'changePackageRequested',
            'changePackageOffered',
            'inReview',
            'reviewed',
          ] as TAppointmentStatus[]
        ).includes(offer?.status);

        return (
          <ScrollSpyContextProvider>
            <PageMetaData
              title={
                (offerId && `Appt ${offerId} | Flayr`) || `${profileId} | Flayr`
              }
            />
            <ProfileDisplayLayout
              navbarSettings={{
                backBtnLabel: 'All providers',
                onBack: handleBack,
                onLearnMore: cancellationPolicyModal.toggle,
                profileImg: provider?.photo,
                name: provider?.name,
                featured: provider?.isFeatured,
                reviewScore: provider?.review?.averageScore,
                reviewCount: provider?.review?.totalCount,
                hideCancellationPolicy: offerBooked,
                message: (offerBooked || offerErr) && (
                  <>
                    {!!offerErr && (
                      <span className="font-medium text-red-500">
                        {offerErr}
                      </span>
                    )}

                    {!!offerBooked && (
                      <span className="font-medium">
                        {/* {offerSuccess} */}
                        <Link
                          to={`/customer-dashboard/inbox/${offer?._id}`}
                          className="px-3 py-1 border border-gray-500 rounded-lg"
                        >
                          <FontAwesomeIcon icon={faComment} className="mr-2" />
                          Contact Stylist
                        </Link>
                      </span>
                    )}
                  </>
                ),
                links: navbarLinks,
                cta: (
                  <CtaBtn
                    placeholder={loading}
                    size="md"
                    label={ctaLabel}
                    hideCtaBtn={isCtaHidden}
                    showPrice={['offered', 'timeChangeRequested'].includes(
                      offer?.status
                    )}
                    showCheckSuccess={['requested'].includes(offer?.status)}
                    deposit={offer?.pricing.deposit}
                    amount={offer?.pricing?.amount}
                    currencySymbol={offer?.pricing?.currencySymbol}
                    onCtaClick={handleCtaClick}
                  />
                ),
                onCtaClick: handleCtaClick,
                ctaExtension: ({ floating }) => {
                  return (
                    (['booked', 'rescheduleRequested'].includes(
                      offer?.status
                    ) && (
                      <>
                        {/* <Button
                          clear
                          className="underline"
                          onClick={rescheduleModal.toggle}
                        >
                          Reschedule
                        </Button> */}

                        <Button
                          clear
                          className={classNames('underline', {
                            'lg:text-white': !floating,
                          })}
                          onClick={changeModal.toggle}
                        >
                          Change
                        </Button>
                        <Button
                          clear
                          className="mr-3"
                          color="danger"
                          onClick={bookingCancellationModal.toggle}
                        >
                          <span
                            className={classNames('underline', {
                              'text-orange-400': !floating,
                            })}
                          >
                            Cancel
                          </span>
                        </Button>
                      </>
                    )) ||
                    (['rescheduleOffered'].includes(offer?.status) && (
                      <Button
                        clear
                        className="mr-3 underline"
                        onClick={rescheduleModal.toggle}
                      >
                        Other
                      </Button>
                    )) ||
                    ([
                      'changePackageRequested',
                      'changePackageOffered',
                    ].includes(offer?.status) && (
                      <Button
                        clear
                        color="danger"
                        className="mr-4"
                        onClick={handleCancelChangeRequest}
                      >
                        <span
                          className={classNames({
                            'text-orange-400': !floating,
                          })}
                        >
                          Cancel Request
                        </span>
                      </Button>
                    )) ||
                    undefined
                  );
                },
              }}
              alertBar={
                <ProfileAlertBar
                  status={offer?.status}
                  offerExpiryTime={
                    (offer?.status === 'rescheduleOffered' &&
                      offer?.timeRescheduleOfferExpires) ||
                    offer?.timeOfferExpires ||
                    undefined
                  }
                  onCountdownComplete={handleOfferExpired}
                  onLearnMore={cancellationPolicyModal.toggle}
                />
              }
              alertBarSticky={offer?.status === 'offered'}
              mediaSection={
                <MediaContainer
                  fetchMediaUrl={fetchMediaUrl}
                  component={ProviderProfileMediaSection}
                  initialMediaItems={
                    (provider?.coverPhoto && [
                      {
                        mediaUrl: provider?.coverPhoto,
                        _id: 'prvmedia',
                        alt: '',
                      },
                    ]) ||
                    []
                  }
                  hideLoader
                  // props to pass to the ProviderProfileMediaSection
                  externalProps={{
                    backBtnDisabled: false,
                    onGoBack: handleBack,
                    fetchMediaUrl: fetchMediaUrl,
                  }}
                />
              }
              avatarSection={
                <ProfileAvatarSection
                  photo={provider?.photo}
                  name={provider?.name}
                  reviewScore={provider?.review?.averageScore}
                  reviewCount={provider?.review?.totalCount}
                  vaccinationStatus={provider?.vaccinationStatus}
                  loading={loading}
                  contactLink={
                    ([
                      'booked',
                      'rescheduleRequested',
                      'rescheduleOffered',
                    ].includes(offer?.status) &&
                      `/customer-dashboard/inbox/${offer?._id}`) ||
                    ''
                  }
                />
              }
              quoteDetailsSection={
                <OfferDetailsSection
                  className="py-8 my-8 border-t border-b lg:my-0 lg:py-0 lg:border-t-0 lg:border-b-0"
                  title="Offer Details"
                  loading={!offer}
                  locationLabel={offerDetailsSection.locationLabel}
                  location={offerDetailsSection.location}
                  dateLabel={offerDetailsSection.dateLabel}
                  date={offerDetailsSection.date}
                  servicesLabel={offerDetailsSection.servicesLabel}
                  services={offerDetailsSection.services as any[]}
                />
              }
              rescheduleSection={
                ['rescheduleRequested', 'rescheduleOffered'].includes(
                  offer?.status || ''
                ) && (
                  <ProviderProfileSection
                    icon={
                      <FontAwesomeIcon
                        icon={faHistory}
                        className="text-2xl text-primary"
                      />
                    }
                    className="pb-8 my-8 border-b lg:border-b-0"
                  >
                    <RescheduleSection
                      title={
                        (offer?.status === 'rescheduleRequested' &&
                          'Reschedule Requested') ||
                        'Reschedule Offered'
                      }
                      {...((offer.status === 'rescheduleRequested' &&
                        offer?.reschedule?.requested) ||
                        offer?.reschedule?.offered)}
                      offered={offer?.status === 'rescheduleOffered'}
                      onAcceptOffer={handleCtaClick}
                      onOther={rescheduleModal.toggle}
                    />
                  </ProviderProfileSection>
                )
              }
              changePackageSection={
                ['changePackageRequested', 'changePackageOffered'].includes(
                  offer?.status
                ) && (
                  <ProviderProfileSection
                    icon={
                      <FontAwesomeIcon
                        icon={faUserPlus}
                        className="text-2xl text-gray-500"
                      />
                    }
                    className="pb-8 my-8 border-b lg:border-b-0"
                  >
                    <div className="font-medium lg:font-normal lg:text-lg">
                      Change Package{' '}
                      {(offer.status === 'changePackageRequested' &&
                        'Requested') ||
                        'Offered'}
                    </div>
                    <div className="mt-2 text-blue-500 underline">
                      <Link
                        to={`/offers/${offer?.replacedWith}`}
                        target="__blank"
                      >
                        View Change Request
                      </Link>
                    </div>
                  </ProviderProfileSection>
                )
              }
              pricingInclusionsSection={
                !!offer?.pricing && (
                  <ProviderProfileSection
                    icon={
                      <FontAwesomeIcon
                        icon={faTag}
                        className="text-2xl text-primary"
                      />
                    }
                    className="my-8"
                  >
                    <PricingInclusions
                      total={offer?.pricing.total || 0}
                      deposit={offer?.pricing?.deposit || 0}
                      amountAfterCredits={offer?.pricing?.amount}
                      remainder={offer?.pricing?.remainder || 0}
                      inclusions={inclusions}
                      credits={offer?.pricing?.credits}
                      bonus={offer?.pricing?.bonus}
                      currency={offer?.pricing?.currencySymbol}
                      totalPostCredits={offer?.pricing?.totalPostCredits}
                      prevDepositUsed={offer?.pricing?.prevDepositUsed}
                      placeholder={loading}
                    />
                  </ProviderProfileSection>
                )
              }
              freeCancellationSection={
                <div
                  hidden={offer?.status === 'booked'}
                  className="-mb-3 text-sm"
                >
                  <CancellationPolicy
                    onClick={cancellationPolicyModal.toggle}
                    date={search?.appointmentSpot?.eventDate}
                  />
                </div>
              }
              ctaSection={
                <div className="my-8" data-testid="cta-container">
                  <CtaBtn
                    placeholder={loading}
                    ctaClassName="max-w-md mx-auto lg:mx-0"
                    label={ctaLabel}
                    errorMessage={
                      <div className="max-w-md mx-auto text-center lg:mx-0">
                        {offerErr}
                      </div>
                    }
                    successMessage={
                      !!offerSuccess && (
                        <div className="flex items-center justify-center w-full mx-auto text-xl font-medium lg:text-3xl">
                          <CheckCircle className="mr-4 text-3xl" /> Booked
                        </div>
                      )
                    }
                    hideCtaBtn={isCtaHidden}
                    showPrice={['offered', 'timeChangeRequested'].includes(
                      offer?.status
                    )}
                    showCheckSuccess={[
                      'requested',
                      'changePackageRequested',
                    ].includes(offer?.status)}
                    deposit={offer?.pricing.deposit}
                    amount={offer?.pricing?.amount}
                    currencySymbol={offer?.pricing?.currencySymbol}
                    onCtaClick={handleCtaClick}
                    showNoObligation={
                      search?.status === 'open' &&
                      !['closed', 'requested'].includes(offer?.status)
                    }
                  />
                  {offer?.status === 'changePackageRequested' && (
                    <Button
                      block
                      color="danger"
                      className="max-w-md mt-3 lg:text-orange-400"
                      clear
                      onClick={handleCancelChangeRequest}
                    >
                      Cancel Change Request
                    </Button>
                  )}
                  <>
                    <div className="hidden" data-testid="fomo-count">
                      {watchersCount}
                    </div>
                    {offer?.location?.countryCode !== 'au' &&
                      ![
                        'requested',
                        'deleted',
                        'bookedOut',
                        'dismissed',
                        'expired',
                        'booked',
                        'cancelled',
                        'cancelledByFlayr',
                        'cancelledByCustomer',
                        'rescheduleRequested',
                        'rescheduleOffered',
                        'changePackageRequested',
                        'changePackageOffered',
                      ].includes(offer?.status) && (
                        <ProfileFomoSection
                          watchersCount={watchersCount}
                          className="px-4 pt-5 mb-2"
                          providerName={provider?.name}
                        />
                      )}

                    {offer?.location?.countryCode === 'au' &&
                      [
                        'requested',
                        'offered',
                        'offerExpired',
                        'timeChangeRequested',
                      ].includes(offer?.status) && (
                        <ProfileFomoSection
                          watchersCount={watchersCount}
                          className="px-4 pt-5 mb-2"
                          providerName={provider?.name}
                        />
                      )}
                  </>
                </div>
              }
              testimonialsSection={
                <TestimonialContainer
                  url={fetchTestimonialsUrl}
                  hideLoader
                  component={ProviderProfileTestimonialsSection}
                />
              }
              bioSection={
                !!provider?.bio && (
                  <ProviderProfileCollapseContainer
                    title="About me"
                    titleClassName="lg:hidden"
                    open
                    disabled={isDesktop}
                    hideIcon={isDesktop}
                    hideTitle={isDesktop}
                  >
                    <ReadMore
                      lines={(isDesktop && 5) || 4}
                      text={provider?.bio}
                      showMoreText="read more"
                      showLessText="show less"
                      showHideTextClassName="block capitalize text-gray-primary font-semibold"
                    />
                  </ProviderProfileCollapseContainer>
                )
              }
              kitSection={
                !!provider?.kit?.length && (
                  <ProviderProfileCollapseContainer
                    title="My Kit"
                    open
                    disabled={isDesktop}
                    hideIcon={isDesktop}
                  >
                    <div className="flex flex-wrap">
                      {kit.map((k, idx) => (
                        <React.Fragment key={k + idx}>
                          <span className="mr-2">{k}</span>
                          {idx < kit.length - 1 && (
                            <div className="self-center flex-none w-1.5 h-1.5 mr-2 rounded-full bg-gray-C4" />
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                  </ProviderProfileCollapseContainer>
                )
              }
              reviewsSection={
                !!provider?.review?.totalCount && (
                  <ReviewsContainer
                    url={fetchReviewsUrl}
                    limit={10}
                    component={ReviewsSection}
                    hideLoader
                    externalProps={{ name: provider?.name }}
                  />
                )
              }
              faqsSection={
                <ProviderProfileCollapseContainer
                  title="FAQs"
                  disabled={isDesktop}
                  hideIcon={isDesktop}
                  open={isDesktop}
                >
                  <Faqs
                    faqs={faqs}
                    questionTextSize="text-lg lg:text-xl leading-[1.5em] text-gray-primary"
                    answerTextSize="text-sm lg:text-base leading-[2em] text-gray-5E"
                  />
                </ProviderProfileCollapseContainer>
              }
              otherOffersSection={<OtherOffersSection offers={otherOffers} />}
              helpSection={
                <div className="bg-[#EEEFEA] -mx-4 text-gray-primary">
                  <NeedHelp code={`${provider?.profileId}_${search?._id}`} />
                </div>
                // <ProviderProfileCollapseContainer
                //   title="Need Help"
                //   disabled={isDesktop}
                //   hideIcon={isDesktop}
                //   open={isDesktop}
                // >
                //   <Help
                //     className="text-gray-5D lg:text-black lg:text-lg"
                //     code={`${provider?.profileId}_${search?._id}`}
                //   />
                // </ProviderProfileCollapseContainer>
              }
              reasonsToBookSection={<ReasonsToBook />}
              footerSection={
                <ProfileFooter
                  className="lg:hidden"
                  placeholder={loading}
                  currency={offer?.pricing?.currencySymbol}
                  pricing={offer?.pricing}
                  onCtaClick={handleCtaClick}
                  onCancel={bookingCancellationModal.toggle}
                  appointment={
                    (!!offer?.status &&
                      ({
                        status: offer?.status,
                        id: offer?._id || `search-${search?._id}`,
                        ...offer?.pricing,
                      } as any)) ||
                    undefined
                  }
                  onCancelChangeRequest={handleCancelChangeRequest}
                  onLearnMore={cancellationPolicyModal.toggle}
                  onReschedule={rescheduleModal.toggle}
                  onChange={changeModal.toggle}
                />
              }
              modalsSection={
                <>
                  <CancellationPolicyModal
                    open={cancellationPolicyModal.opened}
                    onClose={cancellationPolicyModal.toggle}
                  />
                  <ContactModal
                    open={contactModal.opened}
                    onClose={contactModal.toggle}
                    requesterInfo={customer}
                    appointmentId={offer?._id}
                  />

                  {/* change date/time */}
                  <ConditionalWrapper
                    condition={isDesktop}
                    wrapper={(children) => (
                      <Drawer
                        open={newDateTimeModal.opened}
                        onClose={newDateTimeModal.close}
                        className="w-[calc(100vw-100vh)] text-white bg-black bg-opacity-75"
                        direction="right"
                        zIndexClassName="z-20"
                      >
                        {children}
                      </Drawer>
                    )}
                  >
                    <ChangeDateTimeWizard
                      open={newDateTimeModal.opened}
                      offerId={offer?._id}
                      onClose={newDateTimeModal.toggle}
                      onFinish={handleTimeChangeSubmit}
                    />
                  </ConditionalWrapper>

                  <SuccessModal
                    message="Date/Time change requestd"
                    open={dateTimeChangeSuccessModal.opened}
                    onClose={dateTimeChangeSuccessModal.close}
                  />
                  <>
                    {!offer?._id && !isDesktop && (
                      <CheckAvailabilityWizard
                        className="lg:hidden"
                        urlToPostDataTo={checkAvailabilityUrl}
                        country={search?.location?.addressFull?.countryCode}
                        open={checkAvailabilityModal.opened}
                        onClose={checkAvailabilityModal.close}
                        providerName={provider?.name}
                        enableTimeStep={!search?.appointmentSpot?.finishTime}
                        finishTime={search?.appointmentSpot?.finishTime}
                        mobileOrStudio={
                          mobileOrStudio || search?.location.mobileOrStudio
                        }
                        onFinish={handleCheckAvailabilityFinish}
                      />
                    )}

                    {!offer?._id && isDesktop && (
                      <Drawer
                        open={checkAvailabilityModal.opened}
                        onClose={checkAvailabilityModal.close}
                        className="w-[calc(100vw-100vh)] text-white bg-black bg-opacity-75"
                        direction="right"
                        zIndexClassName="z-20"
                      >
                        <CheckAvailabilityWizard
                          drawerView
                          urlToPostDataTo={checkAvailabilityUrl}
                          open={checkAvailabilityModal.opened}
                          onClose={checkAvailabilityModal.close}
                          providerName={provider?.name}
                          country={search?.location?.addressFull?.countryCode}
                          enableTimeStep={!search?.appointmentSpot?.finishTime}
                          finishTime={search?.appointmentSpot?.finishTime}
                          mobileOrStudio={
                            mobileOrStudio || search?.location.mobileOrStudio
                          }
                          onFinish={handleCheckAvailabilityFinish}
                        />
                      </Drawer>
                    )}
                  </>
                  <>
                    {!isDesktop && (
                      <SlideIn
                        open={checkAvailabilitySuccessModal.opened}
                        onClose={checkAvailabilitySuccessModal.close}
                        enableContainer
                      >
                        <CheckAvailabilitySuccess
                          ctaLabel="Close"
                          subTitle="We will email and text you once the provider responds"
                          message=""
                          onCtaClick={checkAvailabilitySuccessModal.close}
                        />
                      </SlideIn>
                    )}
                    {isDesktop && (
                      <SuccessErrDrawer
                        open={checkAvailabilitySuccessModal.opened}
                        onClose={checkAvailabilitySuccessModal.close}
                        className="w-[calc(100vw-100vh)] text-white bg-black bg-opacity-75"
                        title="Availability Check in Progress"
                        successMsg="We will email and text you once the provider responds"
                      />
                    )}
                  </>

                  <SlideIn
                    open={contactProviderSuccessModal.opened}
                    onClose={contactProviderSuccessModal.close}
                    enableContainer
                  >
                    <CheckAvailabilitySuccess
                      ctaLabel="Close"
                      title={`Message sent to ${provider?.name}`}
                      subTitle="We will email and text you once the provider responds"
                      message=""
                      onCtaClick={contactProviderSuccessModal.close}
                    />
                  </SlideIn>

                  <>
                    {!isDesktop && (
                      <CancelBookingWizard
                        open={bookingCancellationModal.opened}
                        onClose={bookingCancellationModal.close}
                        offerId={offerId}
                        onFinish={handleCancelBookingComplete}
                      />
                    )}
                    {isDesktop && (
                      <Drawer
                        open={bookingCancellationModal.opened}
                        onClose={bookingCancellationModal.close}
                        className="w-[calc(100vw-100vh)] text-white bg-black bg-opacity-75"
                        direction="right"
                        zIndexClassName="z-20"
                      >
                        <CancelBookingWizard
                          open={bookingCancellationModal.opened}
                          onClose={bookingCancellationModal.close}
                          offerId={offerId}
                          onFinish={handleCancelBookingComplete}
                          drawerView
                        />
                      </Drawer>
                    )}
                  </>
                  <>
                    {!isDesktop && (
                      <RescheduleBookingWizard
                        offerId={offerId}
                        open={rescheduleModal.opened}
                        rescheduleInProgress={
                          offer?.status === 'rescheduleRequested'
                        }
                        rescheduleOffered={
                          offer?.status === 'rescheduleOffered'
                        }
                        onClose={rescheduleModal.close}
                        onFinish={handleRescheduleComplete}
                        onAcceptOffer={handleAcceptReschedule}
                        onCancelBooking={bookingCancellationModal.toggle}
                      />
                    )}
                    {isDesktop && (
                      <Drawer
                        open={rescheduleModal.opened}
                        onClose={rescheduleModal.close}
                        className="w-[calc(100vw-100vh)] text-white bg-black bg-opacity-75"
                        direction="right"
                        zIndexClassName="z-20"
                        disableBackdropClose
                      >
                        <RescheduleBookingWizard
                          offerId={offerId}
                          drawerView
                          open={rescheduleModal.opened}
                          rescheduleInProgress={
                            offer?.status === 'rescheduleRequested'
                          }
                          rescheduleOffered={
                            offer?.status === 'rescheduleOffered'
                          }
                          onClose={rescheduleModal.close}
                          onFinish={handleRescheduleComplete}
                          onAcceptOffer={handleAcceptReschedule}
                          onCancelBooking={bookingCancellationModal.toggle}
                        />
                      </Drawer>
                    )}
                  </>

                  <>
                    {!isDesktop && (
                      <ChangeBookingWizard
                        offerId={offerId}
                        open={changePackageModal.opened}
                        onClose={changePackageModal.close}
                        selectedServices={offer?.services?.map((s) => s._id)}
                      />
                    )}
                    {isDesktop && (
                      <Drawer
                        open={changePackageModal.opened}
                        onClose={changePackageModal.close}
                        className="w-[calc(100vw-100vh)] text-white bg-black bg-opacity-75"
                        direction="right"
                        zIndexClassName="z-20"
                        disableBackdropClose
                      >
                        <ChangeBookingWizard
                          offerId={offerId}
                          open={changePackageModal.opened}
                          onClose={changePackageModal.close}
                          selectedServices={offer?.services?.map((s) => s._id)}
                          drawerView
                        />
                      </Drawer>
                    )}
                  </>

                  <ConditionalWrapper
                    condition={isDesktop}
                    wrapper={(children) => (
                      <Drawer
                        open={loginModal.opened}
                        onClose={loginModal.close}
                        className="w-[calc(100vw-100vh)] text-white bg-black bg-opacity-75"
                        direction="right"
                        zIndexClassName="z-20"
                        disableBackdropClose
                        children={children}
                      />
                    )}
                  >
                    <LoginWizard
                      open={loginModal.opened}
                      onClose={loginModal.close}
                      onFinish={handleLoginComplete}
                      drawerView={isDesktop}
                      loginWith="email"
                    />
                  </ConditionalWrapper>
                  <>
                    {!isDesktop && (
                      <SlideIn
                        open={!!successMsg}
                        onClose={clearSuccessMsg}
                        enableContainer
                      >
                        <SuccessMsg
                          cta
                          message={successMsg}
                          onCtaClick={clearSuccessMsg}
                        />
                      </SlideIn>
                    )}
                    {isDesktop && (
                      <SuccessErrDrawer
                        open={!!successMsg}
                        onClose={clearSuccessMsg}
                        className="w-[calc(100vw-100vh)] text-white bg-black bg-opacity-75 z-20"
                        successMsg={successMsg}
                      />
                    )}
                  </>

                  <>
                    {!isDesktop && (
                      <SlideIn
                        open={!!errMsg}
                        onClose={clearErrMsg}
                        enableContainer
                      >
                        <ErrorMsg
                          cta
                          message={errMsg}
                          onCtaClick={clearErrMsg}
                        />
                      </SlideIn>
                    )}
                    {isDesktop && (
                      <SuccessErrDrawer
                        open={!!errMsg}
                        onClose={clearErrMsg}
                        className="w-[calc(100vw-100vh)] text-white bg-black bg-opacity-75 z-20"
                        errMsg={errMsg}
                      />
                    )}
                  </>

                  <ConditionalWrapper
                    condition={isDesktop}
                    wrapper={(children) => (
                      <Drawer
                        open={changeModal.opened}
                        onClose={changeModal.close}
                        direction="right"
                        zIndexClassName="z-20"
                        className="w-[calc(100vw-100vh)] text-white bg-black bg-opacity-75 z-20"
                      >
                        {children}
                      </Drawer>
                    )}
                  >
                    <ChangeBookingOptionsWizard
                      open={changeModal.opened}
                      onClose={changeModal.close}
                      onFinish={handleChangeOptionSelect}
                      drawerView={isDesktop}
                    />
                  </ConditionalWrapper>
                </>
              }
            />
          </ScrollSpyContextProvider>
        );
      }}
    </ProviderProfilePageContainer>
  );
};
export default ProfilePageLayout;
